module.exports = "/wp-content/plugins/ratis-app-entschaedigungsmanager/dist/ssl-logo.png?6c72f4be0a75dc9d32f502de04437319";